import { launchPickerModal } from '../client/picker/util';
import { nativeService } from '../native/service';
import { clientApi } from '../client/api';
import { loadDebugBlob } from './load-debug-blob';
import { clientContext } from '../client/context';
import { showClientDebugger } from '../client/debugger/init';
import { nativeStoreKitService } from '../native/native-store-kit-service';


export const showHelpDialog = async () => {
  const result = await launchPickerModal({
    title: 'Help',
    options: [
      { id: 'email', title: 'weathernerdhelp@gmail.com' },
      { id: 'debuglogs', title: 'Submit Error Logs' },
      {
        id: 'refreshReceipt',
        title: 'Refresh Receipt',
      },
      { id: 'code', title: 'Enter Support Code' },
    ],
    multiple: false,
    value: null,
    values: [],
  });

  if (result === 'refreshReceipt') {
    const res = await nativeStoreKitService.refreshReceipt(null);
    alert(`Success: ${res.receipt?.substring(0, 20)}...`);
  }else if (result === 'email') {
    void nativeService.run('open-url', { url: `mailto:weathernerdhelp@gmail.com` });
  } else if (result === 'debuglogs') {
    try {
      const blob = await loadDebugBlob();
      if (clientContext.isLocal) {
        console.log(blob);
      }
      await clientApi.submitDebugLogs({ blob });
      alert(`Success`);
    }catch (e){
      alert(`Error: ${e}`);
    }
  } else if (result === 'code') {
    try {
      const code = prompt('Enter Code');
      if (!code) return;
      if (code === 'debug') {
        await showClientDebugger();
        return;
      }

      const res = await clientApi.enterCode(code);
      if ('receipt' in res) {
        nativeService.context.receipt = res.receipt;
        clientContext.latestReloadRequestTime = new Date().getTime();
      }
      alert(res.alert || `Done`);
    }catch (e){
      alert(`Error: ${e}`);
    }
  }
};